import { useMutation } from "@shared/lib/hooks";
import { INVOICES_QUERY_KEY } from "../constants";
import { AccountingService } from "../services/Accounting.service";
import { ICreditNoteOnInvoice } from "../types";

export function useRaiseCreditNoteOnInvoice() {
  const {
    mutate: raiseCreditNote,
    isLoading: isRaising,
    isSuccess: isRaised,
    error: raiseCreditNoteError,
  } = useMutation<ICreditNoteOnInvoice>({
    mutationFn: async (data: ICreditNoteOnInvoice) => {
      return await AccountingService.raiseCreditNoteOnInvoice(data);
    },
    onSuccess: (c) => {
      c.invalidateQueries({ queryKey: INVOICES_QUERY_KEY });
    },
    options: {
      skipInvalidation: true,
    },
  });

  return {
    raiseCreditNote,
    isRaising,
    isRaised,
    raiseCreditNoteError,
  };
}
